import {createActions} from 'client/framework';

const normalActions = [
  'UPDATE_RESPONSE',
  'LOAD_DRAFT',
  'SAVE_DRAFT',
  'LOAD_GUESS',
  'CANCEL_AUTO_SAVE',
  'START_TIMER',
  'SAVE_CALLBACK'
];

const freeResponseActions = createActions(null, normalActions);

export default freeResponseActions;
